<div class="text-end">
  <div class="d-inline-flex align-items-center gap-2">
    <div class="d-flex align-items-center gap-2">
      <label class="mb-0 text-nowrap text-xs">Filter by Role:</label>
      <select
        v-model="selected_role"
        class="modal-form-select form-select text-xxs rounded-3 p-2 shadow-sm"
        @change="on_role_change"
      >
        <option v-for="role in roles" :key="role.id" :value="role.id">
          {{ role.name }}
        </option>
      </select>
    </div>
    <button
      class="btn btn-primary-dark btn-sm rounded text-xxs shadow"
      data-bs-toggle="modal"
      data-bs-target="#reorder_widgets_modal"
      @click="open_reorder_widgets_modal"
    >
      Re-order widgets
    </button>
  </div>
</div>

<GlobalTable
  v-if="available_widgets.length > 0"
  :headers="widget_headers"
  :data="available_widgets"
  :key="available_widgets"
  table_id="widget_assignment_table">
  <template #actions="{ row }">
    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        :id="'switch_' + row.id"
        :checked="assigned_widgets.includes(row.id)"
        @change="toggle_assignment(row.id, !assigned_widgets.includes(row.id))">
      <label class="form-check-label" :for="'switch_' + row.id">
        {{ assigned_widgets.includes(row.id) ? 'Assigned' : 'Unassigned' }}
      </label>
    </div>
  </template>
</GlobalTable>

<teleport to="body">
  <div
    class="modal fade"
    id="reorder_widgets_modal"
    tabindex="-1"
    aria-labelledby="reorder_widgets_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs">Reorder Widgets</p>
          <button
            type="button"
            class="modal-btn-close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body overflow-auto">
          <div
            class="reorder-instructions text-muted text-xxs mb-3 p-2 bg-info-subtle border-start border-3 rounded"
          >
            <i class="fas fa-info-circle"></i>
            Drag widgets up or down to reorder them
          </div>

          <div class="sortable-list">
            <div
              v-for="(widget, index) in current_reorder_widgets"
              :key="widget.id"
              class="sortable-item mb-2 p-2 border rounded bg-light position-relative cursor-move transition"
              draggable="true"
              @dragstart="drag_start_widget($event, index)"
              @dragover.prevent
              @drop.prevent="drag_drop_widget($event, index)"
              @dragend="drag_end_widget"
            >
              <div class="d-flex align-items-center">
                <div class="drag-handle me-3 text-muted">
                  <i class="fas fa-grip-vertical fs-5"></i>
                </div>

                <div
                  class="question-number card-header-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 text-center text-nowrap text-xs"
                >
                  {{ index + 1 }}
                </div>

                <div class="flex-grow-1">
                  <div class="fw-bold text-xs text-dark">
                    {{ widget.name }}
                  </div>
                  <div class="text-muted text-xxs">
                    {{ widget.description || '—' }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="current_reorder_widgets.length === 0"
              class="text-center text-muted text-xxs py-4"
            >
              No widgets to reorder.
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
            @click="update_widget_order"
          >
            Update Order
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>
